import { render } from "./DiscountCondition.vue?vue&type=template&id=65191710&ts=true"
import script from "./DiscountCondition.vue?vue&type=script&lang=ts"
export * from "./DiscountCondition.vue?vue&type=script&lang=ts"

import "./DiscountCondition.vue?vue&type=style&index=0&id=65191710&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__